import { Token } from '@kodiak-finance/sdk-core'
import { SupportedChainId } from 'config/chains'
import { useConnection } from 'hooks/useConnection'
import tryParseCurrencyAmount from 'lib/utils/tryParseCurrencyAmount'
import { useMemo } from 'react'

import { BUSD_BERA, USDG_ROBINHOOD } from '../constants/tokens'

// Stablecoin amounts used when calculating spot price for a given currency.
// The amount is large enough to filter low liquidity pairs.

export const MAIN_STABLECOIN: { [chainId: number]: Token } = {
  [SupportedChainId.BEPOLIA]: BUSD_BERA,
  [SupportedChainId.BERA]: BUSD_BERA,
  [SupportedChainId.ROBINHOOD]: USDG_ROBINHOOD,
}

export function stablecoinAmountFromFiatValue(fiatValue: string | null | undefined, chainId: number | undefined) {
  const stablecoin = chainId !== undefined ? MAIN_STABLECOIN[chainId] : undefined
  if (fiatValue === null || fiatValue === undefined || !stablecoin) return undefined

  // trim for decimal precision when parsing
  const parsedForDecimals = parseFloat(fiatValue).toFixed(stablecoin.decimals).toString()
  try {
    return tryParseCurrencyAmount(parsedForDecimals, stablecoin)
  } catch (error) {
    return undefined
  }
}

/**
 *
 * @param fiatValue string representation of a USD amount
 * @returns CurrencyAmount where currency is stablecoin on active chain
 */
export function useStablecoinAmountFromFiatValue(fiatValue: string | null | undefined) {
  const { chainId } = useConnection()
  return useMemo(() => stablecoinAmountFromFiatValue(fiatValue, chainId), [chainId, fiatValue])
}
